"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _H = _interopRequireDefault(require("../text/H5"));

var _Card = _interopRequireDefault(require("../nav/Card"));

var _Illustration = _interopRequireDefault(require("../Illustration"));

var _StringOrRender = _interopRequireDefault(require("../helper/StringOrRender"));

var _styling = require("../../toolkit/styling");

/* Lego Components */

/* Lego Toolkit */

/* eslint-disable local-rules/unwrapped-i18n */
var demoProps = {
  title: "Basic Info"
};
var demoRender = "\n<FormSectionCard title=\"Basic Info\" style={{minWidth: 500}}>\n  <HorizontalField\n    title=\"First Name\"\n    titleWidth={130}\n    centerTitleVertically\n    style={{ marginBottom: 20 }}\n  >\n    <TextInput placeholder=\"Enter your first name\" />\n  </HorizontalField>\n  <HorizontalField title=\"Last Name\" titleWidth={130} centerTitleVertically>\n    <TextInput placeholder=\"Enter your last name name\" />\n  </HorizontalField>\n</FormSectionCard>\n";
/* eslint-disable local-rules/unwrapped-i18n */

var propDoc = {
  title: {
    required: true,
    type: "string | ((() => ReactNode))",
    description: "Title of the section"
  }
};

var FormSectionCard = function FormSectionCard(props) {
  var styles = useStylesheet();
  var className = props.className,
      style = props.style,
      title = props.title,
      children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    className: (0, _styling.css)(styles.root, className, style)
  }, /*#__PURE__*/_react["default"].createElement(_Illustration["default"], {
    name: "cardTexture",
    className: (0, _styling.css)(styles.illustration),
    alt: "card texture",
    animate: false
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.titleContainer)
  }, /*#__PURE__*/_react["default"].createElement(_H["default"], {
    className: (0, _styling.css)(styles.title)
  }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
    value: title
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.content)
  }, children));
};

FormSectionCard.propDoc = propDoc;
FormSectionCard.demoProps = demoProps;
FormSectionCard.demoRender = demoRender;

var _default = (0, _mobxReact.observer)(FormSectionCard);

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        padding: 20,
        display: "flex",
        flexDirection: "column",
        position: "relative"
      },
      titleContainer: {
        top: 0,
        left: 0,
        padding: 20,
        position: "absolute"
      },
      title: {
        marginBottom: 10
      },
      illustration: {
        height: 120,
        top: 0,
        right: 0,
        position: "absolute"
      },
      content: {
        marginTop: 40
      }
    });
  }, []);
};